// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"b7334b68","87":"7070fd6f","122":"8609550e","228":"088f8260","268":"01834f8d","384":"3e766aab","435":"2a294b65","506":"31d6cfe0","508":"ca31886b","581":"68b86b46","930":"8df6565a"}[chunkId] + ".chunk.css";
};